module.exports = __webpack_public_path__ + "media/kojic-large.ba9016c5.mp4";